import React from 'react';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import THEATER_INFO_QUERY from '../../../graphql/TheaterInfo';

const TheaterWidget = (props) => {
  const { theater } = props;
  if (theater !== undefined) {
    return (
      <div className="col-lg-4 col-md-4 col-xs-12">
        <div className="sidebar right">
          <div className="thumbnail recent-properties-box">
            <img
              src={theater.images[0].url}
              alt="properties-5"
              className="img-responsive"
            />
            <div className="caption detail">
              <header className="clearfix">
                <div className="pull-left">
                  <h1 className="title">
                    <Link to={`/theater/${theater.slug}`}>{theater.name}</Link>
                  </h1>
                </div>
              </header>
              <h3 className="location">
                <a href="">
                  <i className="fa fa-map-marker" />
                  {`${theater.address}, ${theater.city}`}
                </a>
              </h3>
              <a href={theater.website} target="_blank" rel="noopener noreferrer" className="book-btn">
                <span className="book-btn-l">
                  <i className="fa fa-link" />
                </span>
                <span className="book-btn-r">Página web</span>
                <div className="clear" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <div />;
}

const withTheater = graphql(THEATER_INFO_QUERY, {
  skip: ownProps => ownProps.theater,
  // eslint-disable-next-line camelcase
  options: ({ theater_id }) => ({
    variables: {
      id: theater_id,
    },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    theater: data.theater,
  }),
});

export default withTheater(TheaterWidget);



// WEBPACK FOOTER //
// ./src/containers/Others/TheaterWidget/index.js